import api, { unwrap } from './client';

/* Emprunts et apports, MODE MANUEL (2026-10-03) : les comptes de fonds
   étrangers retenus et leurs remboursements à venir. Le calcul (soldes,
   cumul, effet au bilan) vit au SERVEUR ; chaque écriture renvoie la vue. */
export const getDebts = (tenantId, year) =>
  unwrap(api.get(`/financials/debts/${tenantId}`, { params: { year } }));

export const putDebtAccounts = (tenantId, year, accounts) =>
  unwrap(api.put(`/financials/debts/${tenantId}/accounts`, { accounts }, { params: { year } }));

export const putDebtRepay = (tenantId, year, account, month, amount) =>
  unwrap(api.put(`/financials/debts/${tenantId}/repay`, { account, month, amount }, { params: { year } }));
